import { __assign, __spreadArray, __read } from 'tslib';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { TreeCardContainer } from './TreeCardContainer.js';
import { TreeCardContent } from './TreeCardContent.js';
import { TreeLines } from './TreeLines.js';

var TreeNodes = function (props) {
    var _a = props.levelHistory, levelHistory = _a === void 0 ? [] : _a, _b = props.data, data = _b === void 0 ? [] : _b, _c = props.isNodeVisible, isNodeVisible = _c === void 0 ? true : _c, context = props.context;
    var _d = context || {}, keyDownHandler = _d.keyDownHandler, onFocus = _d.onFocus, listRef = _d.listRef, activeNode = _d.activeNode, listItemRefs = _d.listItemRefs, getActiveRefIndexFromId = _d.getActiveRefIndexFromId;
    var isRootLevel = levelHistory.length < 1;
    var level = levelHistory.length;
    var getTabIndex = function (nodeId) {
        if (!activeNode) {
            if (nodeId === data[0].id) {
                return 0;
            }
        }
        else {
            if (activeNode.id === nodeId) {
                return 0;
            }
        }
        return -1;
    };
    if (!data.length)
        return null;
    return (jsx("ul", __assign({ role: isRootLevel ? "tree" : "group", onKeyDown: isRootLevel ? keyDownHandler : undefined, ref: isRootLevel ? listRef : null }, { children: data.map(function (node, i, _a) {
            var _b;
            var length = _a.length;
            var isExpandable = Boolean(node.children && Array.isArray(node.children) && node.children.length);
            var listItemRef = listItemRefs[getActiveRefIndexFromId(node.id)] || null;
            var isLastNode = length - 1 === i;
            var updatedNodeHistory = __spreadArray(__spreadArray([], __read(levelHistory), false), [
                {
                    level: level + 1,
                    node: node,
                    isParentLastNode: isLastNode,
                },
            ], false);
            // Get child nodes
            var childNodes = (isExpandable &&
                ((_b = node.children) === null || _b === void 0 ? void 0 : _b.length) &&
                TreeNodes({
                    data: node.children,
                    levelHistory: updatedNodeHistory,
                    isNodeVisible: Boolean(node.expanded),
                    context: context,
                })) ||
                null;
            return (jsxs("li", __assign({ ref: listItemRef, role: "treeitem", "aria-label": node.label, "aria-expanded": node.expanded, style: __assign({}, (isNodeVisible ? {} : { display: "none" })), tabIndex: getTabIndex(node.id), onFocus: onFocus }, (isRootLevel && i === 0 && { "data-first-node": true }), { children: [jsx(TreeCardContainer, { children: function (_a) {
                            var containerRef = _a.containerRef, height = _a.height;
                            return (jsxs(Fragment, { children: [level > 0 && (jsx(TreeLines, { height: height, levelHistory: updatedNodeHistory })), jsx(TreeCardContent, { ref: containerRef, isExpandable: isExpandable, isNodeVisible: isNodeVisible, node: node })] }));
                        } }), childNodes] }), node.id + level + i));
        }) })));
};

export { TreeNodes };
//# sourceMappingURL=TreeNodes.js.map
